/**
 * ComingSoonSocialPage - Main Container Component
 * Landing page with hero section, principles, and video
 *
 * This is a modularized version of the original ComingSoonSocialPage
 * Components are split into separate files for better maintainability
 */

import React from 'react';
import { bool, func } from 'prop-types';
import { useHistory } from 'react-router-dom';
import HeroSection from './components/HeroSection';

import FooterContainer from '../../FooterContainer/FooterContainer';
import classes from './ComingSoonSocialPage.module.css';

// Global Promise error handler to catch unhandled rejections
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', event => {
    console.warn('Unhandled promise rejection:', event.reason);
    event.preventDefault();
  });
}

const ComingSoonSocialPage = ({
  onLoginClick = () => {},
  showExplore = true,
  onExploreClick = () => {},
}) => {
  const history = useHistory();

  const handleExploreClick = e => {
    e.preventDefault();
    e.stopPropagation();
    if (onExploreClick) {
      onExploreClick(e);
    } else {
      history.push('/signup');
    }
  };

  const handleLoginClick = e => {
    e.preventDefault();
    e.stopPropagation();
    if (onLoginClick) {
      onLoginClick(e);
    } else {
      history.push('/login');
    }
  };

  return (
    <div className={classes.pageWrapper}>
      <HeroSection onLoginClick={handleLoginClick} onExploreClick={handleExploreClick} />

      <FooterContainer />
    </div>
  );
};

ComingSoonSocialPage.propTypes = {
  onLoginClick: func,
  showExplore: bool,
  onExploreClick: func,
};

export default ComingSoonSocialPage;
